import React, { useEffect, useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
//styles
import styles from "./notification.module.scss";
//styles
import { NotificationType } from "./types";
import classNames from "classnames";
import { useAppStore } from "@/providers/app";

const Notification = () => {
  const setAppState = useAppStore((state) => state.setAppState);
  const notification = useAppStore((state) => state.notification);
  const [open, setOpen] = useState<boolean>(notification?.show);

  useEffect(() => {
    setOpen(notification?.show);
    if (notification?.show) {
      setTimeout(() => {
        // setOpen(false);
        // onClose();
        setAppState({
          notification: {
            message: "",
            type: NotificationType.NORMAL,
            show: false,
          },
        });
      }, 2000);
    }
  }, [notification?.show]);

  const dropIn = {
    hidden: {
      y: "-100vh",
      opacity: 0,
    },
    visible: {
      y: "0",
      opacity: 1,
      transition: {
        duration: 0.4,
        type: "tween",
      },
    },
    exit: {
      y: "-100vh",
      opacity: 0,
      transition: {
        duration: 0.7,
        type: "tween",
      },
    },
  };

  const type = useMemo(() => {
    switch (notification?.type) {
      case NotificationType.ERROR:
        return styles.error;
      case NotificationType.SUCCESS:
        return styles.success;
      default:
        return styles.success;
    }
  }, [notification?.type]);

  return (
    <AnimatePresence initial={false} exitBeforeEnter={true}>
      {open && (
        <motion.div
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={classNames(styles.container, styles["ph-24"], type)}
        >
          <div>
            <p className={styles.title}>{notification?.message}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Notification;
